import { api } from './client'

// Pagination knobs live on the caller. The Intelligence screen
// uses a large limit (100) to bucket client-side without extra
// round-trips; the Dashboard preview keeps the server-side default
// (10). Both surfaces honor ``offset`` so a future deep-pagination
// pass can keep pulling without rewriting the API client.
export const feedApi = {
  get: (token, { limit, offset } = {}) => {
    const params = []
    if (limit != null) params.push(`limit=${encodeURIComponent(limit)}`)
    if (offset != null) params.push(`offset=${encodeURIComponent(offset)}`)
    const qs = params.length ? `?${params.join('&')}` : ''
    return api.get(`/feed${qs}`, token)
  },
  markRead: (itemId, token) => api.post(`/feed/${itemId}/read`, {}, token),
  generate: (token) => api.post('/feed/generate', {}, token),
}
